// Copyright (c) 2024 Proto Labs, Inc. All Rights Reserved.

import { createHead } from 'unhead'
import { useI18n } from 'vue-i18n';
import { HeaderLink } from '@/models/models';
import { onBeforeUnmount } from 'vue';
import analytics from '@/utils/analytics';

export const useHeaderComposable = () => {
    const { locale } = useI18n();

    const uri = window.location.hostname;

    let alternateLinkEntry: any = null;
    const createHeaderLinks = (path: string) => {
        const head = createHead();
        const headerLinks = analytics.getHeaderLinks(path, uri);

        const canonicalLink = new HeaderLink({rel: 'canonical', href: `https://${uri}/${path}?lang=${locale.value}`, hrefLang: ''});
        const defaultLink = new HeaderLink({rel: 'alternate', href: `https://${uri}/${path}`, hrefLang: 'x-default'});

        const alternateLinks =  [
              canonicalLink,
              ...headerLinks,
              defaultLink
            ];
        alternateLinkEntry = head.push(
          {
            // @ts-expect-error
            link: alternateLinks,
          }
        )

        return alternateLinks;
    };



    onBeforeUnmount(() => {
        if(alternateLinkEntry) {
            alternateLinkEntry.dispose();
        }
    });

    return {
      createHeaderLinks,
    };
}
